<template>
    <div>
        <form id="payment-form">
            <div id="payment-element">
                <!-- Elements will create form elements here -->
            </div>
            <div id="error-message">
                <!-- Display error message to your customers here -->
            </div>
        </form>
    </div>
</template>

<script>
    /* eslint-disable */
    import PracticesAPI from 'api/PracticesAPI'

    export default {
        data() {
            return {}
        },

        methods: {
            initStripe() {
                this.isLoading = true
                PracticesAPI.setupIntent().then((res) => {
                    this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
                    const options = {
                        clientSecret: res.client_secret,
                        // Fully customizable with appearance API.
                        appearance: {
                            /*...*/
                        },
                    }
                    // Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 2
                    this.elements = this.stripe.elements(options)
                    // Create and mount the Payment Element
                    const paymentElement = this.elements.create('payment')
                    paymentElement.mount('#payment-element')
                    this.$emit('stripe-loaded')
                })
            },

            async submitPayment() {
                const { error } = await this.stripe.confirmSetup({
                    //`Elements` instance that was used to create the Payment Element
                    elements: this.elements,
                    confirmParams: {
                        return_url: `${env('VUE_APP_URL')}`,
                    },
                    redirect: 'if_required',
                })

                if (error) {
                    // This point will only be reached if there is an immediate error when
                    // confirming the payment. Show error to your customer (for example, payment
                    // details incomplete)
                    const messageContainer = document.querySelector('#error-message')
                    messageContainer.textContent = error.message
                    this.$emit('payment-details-failed')
                } else {
                    this.$emit('payment-details-saved')
                    // Your customer will be redirected to your `return_url`. For some payment
                    // methods like iDEAL, your customer will be redirected to an intermediate
                    // site first to authorize the payment, then redirected to the `return_url`.
                }
            },
        },

        mounted() {
            this.initStripe()
        },
    }
</script>

<style lang="scss">
    #error-message {
        color: #df1b41;
    }
</style>
